export default {
  bankTransfer: 'Bonifico bancario',
  firstTitle: 'Seleziona la valuta del bonifico',
  secondTitle: 'Dopo il bonifico',
  bankTips:
    "Ottieni le informazioni del beneficiario e recati presso la filiale bancaria corrispondente per compilare la disposizione di bonifico. Verifica attentamente l'ortografia.",
  receiverTitle: 'Informazioni del beneficiario',
  bankAttrEnum: {
    0: 'Numero di conto',
    1: 'Numero di routing',
    2: 'Nome del conto',
    3: 'Nome della banca',
    4: 'Indirizzo della banca',
    5: 'Codice postale',
    6: 'Paese/Regione',
    7: 'Tipo di conto',
    8: 'Nota',
  },
  transferTips:
    'Puoi informarci in uno dei seguenti modi e verificheremo il tutto il prima possibile!',
  transferName: 'Nome del mittente',
  transferBank: 'Banca del mittente',
  transferNo: 'Numero di riferimento',
  submit: 'Invia ora',
  successSubmit: 'Invio riuscito',
  successSubmitTips:
    '* In caso di problemi durante la verifica, contatteremo il tuo indirizzo e-mail di registrazione acbuy.',
  tradeDetail: 'Dettaglio della transazione',
  backOrder: "Torna all'ordine",
  holder: {
    inputNo: 'Si prega di fornire il numero di riferimento, se disponibile.',
  },
  transferExplain: 'Istruzioni per il bonifico bancario:',
  transferExplainEnum: {
    0: "acbuy non addebita commissioni di gestione per questa modalità di pagamento. L'addebito di commissioni da parte della banca emittente dipende dalle politiche corrispondenti di tale banca.",
    1: 'Questa modalità di pagamento supporta diverse valute. I clienti possono scegliere il conto bancario corrispondente per il bonifico in base alla loro regione e alle loro esigenze.',
    2: 'Normalmente, il tempo di accredito è di 1-3 giorni lavorativi; in circostanze particolari, sono necessari 1-5 giorni lavorativi.',
    3: "acbuy convertirà l'importo in RMB al tasso di cambio di acbuy al ricevimento del bonifico, quindi lo accrediterà sul tuo conto.",
    4: "L'importo finale in RMB sul conto acbuy = L'importo del tuo bonifico * il tasso di cambio della piattaforma acbuy.",
  },
}
